var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'valueTd',
    'eldCount',
    _vm.item.align,
    { active: !!_vm.line[_vm.item.value] }
  ]},[_c('button',{attrs:{"disabled":!_vm.line[_vm.item.value]},on:{"click":function($event){return _vm.onClick('count')}}},[_vm._v(" "+_vm._s(_vm.line[_vm.item.value])+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }